<template>
 <div class="body">
<header>
  <h2>3D web projects</h2>
</header>

<section>
  <nav>
    <h4>Menu</h4>
    <ul>
      <li><router-link to="/basic_test">Basic setup</router-link></li>
    </ul>

    <small>
    <h4>Other environments</h4>
      <a href="/music">Music</a> •
      <a href="/programming">Programming</a> •
      <a href="/artificial_intelligence">Artificial intelligence</a>
    </small>
  </nav>

  <router-view/>
  
</section>
  
  <footerModule/>
  
</div>
</template>

<script>

import footerModule from '../components/footer.vue'

export default {
   name: 'Research_Philosophy',
   components: {footerModule}
}
</script>

<style scoped>
* {
  box-sizing: border-box;
}

body {
  font-family: Arial, Helvetica, sans-serif;
  background-color:rgb(63, 63, 63);
}

/* Style the header */
header {
  background-color: rgb(64, 65, 109);
  padding: 10px;
  text-align: center;
  font-size: 20px;
  color: white;
}

/* Create two columns/boxes that floats next to each other */
nav {
  float: left;
  width: 20%;
  height: 600px;  
  background: #ccc;
  padding: 20px;
}

nav a{
  text-decoration: none;
}
nav a:hover{
  color: brown;
}


/* Style the list inside the menu */
nav ul {
  list-style-type: none;
  padding: 0;
}

article {
  float: left;
  padding: 20px;
  width: 70%;
  background-color: #f1f1f1;
  height: 70%; 
}

/* Clear floats after the columns */
section::after {
  content: "";
  display: table;
  clear: both;
}

/* Responsive layout - makes the two columns/boxes stack on top of each other instead of next to each other, on small screens */
@media (max-width: 600px) {
  nav, article {
    width: 100%;
    height: auto;
  }
}
</style>


// WEBPACK FOOTER //
// src/views/3DWeb.vue